// Names can arrive HTML-escaped ("SG &amp; India"); React would show the entity
// literally. DOMParser builds an inert document, so this never runs markup.
export const decodeEntities = value =>
  typeof value === "string" && value.includes("&")
    ? new DOMParser().parseFromString(value, "text/html").documentElement.textContent
    : value;
